<mj-page-layout>
    <mj-page-body>
        <!-- The mockup's `.top`: a bare 27px/800 h1 over one sub line, no icon chip (search.html:305). -->
        <agu-plain-header Title="Search everything" Sub="Across grants, people and jobs" />

        <!--
          `.searchbar` (search.html:308-311): the field fills the row on a
          sunken ground with the magnifier inside it, and the Search button is a
          solid blue block beside it — not MJ's search component and not an
          outlined action.
        -->
        <div class="ra-search__bar">
            <label class="ra-search__field">
                <agu-icon Name="search" [Size]="19" />
                <input
                    type="search"
                    aria-label="Search everything"
                    [value]="queryDraft"
                    (input)="OnQueryInput($event)"
                    (keydown.enter)="OnSubmit()"
                />
            </label>
            <button type="button" class="ra-search__go" (click)="OnSubmit()">Search</button>
        </div>

        @if (searchedQuery !== null) {
            <agu-tab-strip Variant="pill" [Tabs]="Tabs" [Active]="activeTab" [PanelId]="ResultsPanelId" (ActiveChange)="OnTabChange($event)" />

            <!-- A failed load shows no count line (P/proto-states.js:117, `#count` ''). -->
            @if (!error) {
                <p class="ra-search__count">
                    <b>{{ DisplayRows.length }}</b> result{{ DisplayRows.length === 1 ? '' : 's' }} for “{{ searchedQuery }}”
                </p>
            }
        }

        <div [id]="ResultsPanelId" role="tabpanel">
            <!-- Product states (PD §5): 3 skeleton cards (P/proto-states.js:130), the error panel (:115), no results (:101). -->
            @if (loading) {
                <agu-skeleton [Count]="3" />
            } @else if (error) {
                <agu-state-panel
                    Variant="error"
                    [Icon]="ErrorCopy.Icon"
                    [Title]="ErrorCopy.Title"
                    [Body]="ErrorCopy.Body"
                    PrimaryLabel="Try again"
                    [SecondaryLabel]="failures.SupportHref ? 'Contact support' : null"
                    [SecondaryHref]="failures.SupportHref"
                    [Foot]="failures.Foot"
                    [Note]="failures.Note"
                    (Primary)="Retry()"
                />
            } @else if (searchedQuery === null) {
                <agu-state-panel Icon="search" Title="Search everything" Body="Search across grants, people and jobs in one place." />
            } @else if (IsEmpty) {
                <agu-state-panel
                    [Icon]="EmptyCopy.Icon"
                    [Title]="EmptyCopy.Title"
                    [Body]="EmptyCopy.Body"
                    PrimaryLabel="Browse grants"
                    SecondaryLabel="Browse people"
                    (Primary)="OnBrowse('grants')"
                    (Secondary)="OnBrowse('people')"
                />
            } @else {
                <div class="ra-search__list">
                    <!--
                      `.titem` (search.html:267-273): a full-height rail in the
                      kind's own colour, then the kind eyebrow, title and meta.
                      The colour arrives through `[data-accent]` — the same
                      `--accent` cascade Home's pick rows use — so a kind is
                      re-inked by editing its module definition, not this page.
                    -->
                    <!--
                      The row's real control is its title: `h2 > button` (P/search.html:910), the same pattern the finder cards use. The button's
                      ::after stretches over the whole row, so the row stays one tap target.
                    -->
                    @for (row of DisplayRows; track row.key) {
                        <article class="ra-search__row" [attr.data-accent]="AccentFor(row.kind)">
                            <span class="ra-search__rail" aria-hidden="true"></span>
                            <div class="ra-search__row-body">
                                <span class="ra-search__row-kind">{{ KindLabel[row.kind] }}</span>
                                <h2 class="ra-search__row-title">
                                    <button type="button" class="ra-search__row-btn" (click)="OnOpenRow(row)">{{ row.title }}</button>
                                </h2>
                                <span class="ra-search__row-meta">{{ row.metaLine }}</span>
                            </div>
                            <span class="ra-search__row-arrow" aria-hidden="true">→</span>
                        </article>
                    }
                </div>
            }
        </div>
    </mj-page-body>
</mj-page-layout>
